import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { Avatar } from "antd"
import imgStar from "../../../../images/star_admin.svg"
import { ROLE_MANDU_ADMIN } from "../../../../utils/constants"

const isAdministrator = (idRole) => {
  if (idRole === ROLE_MANDU_ADMIN) return <Fragment>Administrador</Fragment>
}

const isSuperAdministrator = (idRole) => {
  if (idRole !== ROLE_MANDU_ADMIN)
    return (
      <Fragment>
        {" "}
        <img
          style={{ marginTop: "-5px" }}
          src={imgStar}
        /> Superadministrador{" "}
      </Fragment>
    )
}

const elementHtml = ({ currentData, userSelected }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "45px auto",
      alignItems: "end",
    }}>
    <Avatar
      src={
        currentData.picture_profile ? currentData.picture_profile : undefined
      }
    />
    <div>
      <span className="ManduUserDrawerComponent-title">
        {userSelected.full_name}{" "}
      </span>
      <span
        className="color-gray-low"
        style={{ fontWeight: 400, verticalAlign: "top", marginLeft: 5 }}>
        - {isAdministrator(userSelected.id_role)}
        {isSuperAdministrator(userSelected.id_role)}
      </span>
    </div>
  </div>
)
const UserManduTitle = (props) => {
  const { isNew, currentData, userSelected } = props
  if (isNew) return "Crear administrador Mandü"
  if (!isNew) return elementHtml({ currentData, userSelected })
}

UserManduTitle.propTypes = {
  isNew: PropTypes.bool,
  currentData: PropTypes.object,
  userSelected: PropTypes.object,
}

export default UserManduTitle
